import { ProfileScreenTabs } from "app/utils/const";

const GetTabsHelper = (state, data, setTab) => {
  return [
    {
      title: data.intl.formatMessage({
        id: "profile-personal-details",
      }),
      callback: () => setTab(ProfileScreenTabs.PERSONAL_DETAILS),
      isActive: state.tab === ProfileScreenTabs.PERSONAL_DETAILS,
      id: "personal-details_button",
    },
    {
      //translate titles
      title: data.intl.formatMessage({
        id: "security_button",
      }),
      callback: () => setTab(ProfileScreenTabs.SECURITY),
      isActive: state.tab === ProfileScreenTabs.SECURITY,
      id: "security_button",
    },
    {
      title: data.intl.formatMessage({
        id: "preferences",
      }),
      callback: () => setTab(ProfileScreenTabs.PREFERENCES),
      isActive: state.tab === ProfileScreenTabs.PREFERENCES,
      id: "preferences_button",
    },
  ];
};

export default GetTabsHelper;
